export enum HostType {
  FullHosted = 'FULL',
  HybridHosted = 'HYBRID'
}
